import React, { useEffect, createElement } from 'react';
import { CheckCircleIcon, AlertTriangleIcon, BotIcon, LightbulbIcon, SmartphoneIcon, RocketIcon, ZapIcon, CalendarIcon, PhoneIcon, MapPinIcon, PenLineIcon, MailIcon, QuoteIcon, StarIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
declare global {
  interface Window {
    fbq: any;
  }
}
export function LlamadaConfirmationPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'Schedule');
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans overflow-x-hidden" data-id="element-2713">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-2714">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=Schedule&noscript=1" alt="" data-id="element-2715" />
      </noscript>

      {/* HERO BANNER */}
      <div className="bg-gradient-to-r from-[#00f7fc]/20 to-[#00d7dc]/10 border-b border-[#00f7fc]/30 py-10 md:py-16 px-4" data-id="element-2716">
        <div className="max-w-3xl mx-auto text-center" data-id="element-2717">
          <div className="flex justify-center mb-5" data-id="element-2718">
            <div className="w-20 h-20 bg-[#00f7fc]/10 border-2 border-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-2719">
              <CheckCircleIcon className="w-10 h-10 text-[#00f7fc]" data-id="element-2720" />
            </div>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-black uppercase leading-tight tracking-tight mb-4" data-id="element-2721">
            Tu Llamada Está <span className="text-[#00f7fc]" data-id="element-2722">Confirmada</span>
          </h1>
          <p className="text-base md:text-lg text-gray-300 flex items-center justify-center gap-2" data-id="element-2723">
            <MailIcon className="w-5 h-5 text-[#00f7fc] flex-shrink-0" data-id="element-2724" />
            Revisa tu email para los detalles de conexión
          </p>
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-4 py-10 md:py-16 space-y-12 md:space-y-16" data-id="element-2725">
        {/* IMPORTANT WARNING */}
        <section data-id="element-2726">
          <div className="bg-yellow-500/10 border-2 border-yellow-500/40 rounded-2xl p-6 md:p-8" data-id="element-2727">
            <div className="flex items-start gap-4" data-id="element-2728">
              <div className="flex-shrink-0 w-10 h-10 bg-yellow-500/20 rounded-full flex items-center justify-center" data-id="element-2729">
                <AlertTriangleIcon className="w-5 h-5 text-yellow-400" data-id="element-2730" />
              </div>
              <div data-id="element-2731">
                <h2 className="text-lg md:text-xl font-black uppercase tracking-wide text-yellow-400 mb-2" data-id="element-2732">
                  IMPORTANTE: Lee Esto Antes de Cerrar Esta Página
                </h2>
                <p className="text-gray-200 text-base md:text-lg leading-relaxed" data-id="element-2733">
                  Estás A <span className="font-black text-white" data-id="element-2734">UN PASO</span>{' '}
                  de Descubrir El Sistema de IA Que Está Cambiando Negocios en
                  Miami
                </p>
                <p className="text-gray-400 mt-3 text-sm md:text-base leading-relaxed" data-id="element-2735">
                  En tu llamada, te mostraremos exactamente cómo usar
                  herramientas de inteligencia artificial para construir un
                  negocio digital real, desde cero, sin experiencia previa.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* WHAT WILL HAPPEN ON YOUR CALL */}
        <section data-id="element-2736">
          <div className="text-center mb-8" data-id="element-2737">
            <div className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 rounded-full px-4 py-2 mb-4" data-id="element-2738">
              <CheckCircleIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-2739" />
              <span className="text-sm font-semibold text-[#00f7fc] uppercase tracking-wide" data-id="element-2740">
                Lo Que Va a Pasar En Tu Llamada
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-4" data-id="element-2741">
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-2742">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-2743">
                <BotIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-2744" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-2745">
                Te mostraremos el sistema exacto de{' '}
                <span className="font-bold text-white" data-id="element-2746">
                  48 Horas AI Cash Machine
                </span>
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-2747">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-2748">
                <LightbulbIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-2749" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-2750">
                Aprenderás cómo la IA puede{' '}
                <span className="font-bold text-white" data-id="element-2751">
                  transformar tu negocio
                </span>{' '}
                desde hoy
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-2752">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-2753">
                <SmartphoneIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-2754" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-2755">
                Todo desde tu{' '}
                <span className="font-bold text-white" data-id="element-2756">celular o laptop</span>,
                sin oficina ni empleados
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-2757">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-2758">
                <RocketIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-2759" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-2760">
                <span className="font-bold text-white" data-id="element-2761">
                  Sin experiencia técnica
                </span>{' '}
                requerida
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4 md:col-span-2" data-id="element-2762">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-2763">
                <ZapIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-2764" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-2765">
                Un sistema diseñado para{' '}
                <span className="font-bold text-white" data-id="element-2766">
                  implementarse rápidamente
                </span>
              </p>
            </div>
          </div>
        </section>

        {/* BEFORE YOUR CALL - STEPS */}
        <section data-id="element-2767">
          <div className="bg-gray-900/50 border border-gray-800 rounded-2xl p-6 md:p-10" data-id="element-2768">
            <div className="flex items-center gap-3 mb-8" data-id="element-2769">
              <div className="w-8 h-8 bg-[#00f7fc]/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-2770">
                <AlertTriangleIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-2771" />
              </div>
              <h2 className="text-xl md:text-2xl font-black uppercase tracking-tight" data-id="element-2772">
                Antes de Tu Llamada, Haz Esto{' '}
                <span className="text-[#00f7fc]" data-id="element-2773">Ahora</span>
              </h2>
            </div>

            <div className="space-y-5" data-id="element-2774">
              {/* Step 1 */}
              <div className="flex items-start gap-4" data-id="element-2775">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-2776">
                  <CalendarIcon className="w-5 h-5 text-black" data-id="element-2777" />
                </div>
                <div data-id="element-2778">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-2779">
                    Paso 1
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-2780">
                    Marca la fecha y hora en tu calendario ahora mismo
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex items-start gap-4" data-id="element-2781">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-2782">
                  <PhoneIcon className="w-5 h-5 text-black" data-id="element-2783" />
                </div>
                <div data-id="element-2784">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-2785">
                    Paso 2
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-2786">
                    Guarda este número en tu teléfono para no perder la llamada
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start gap-4" data-id="element-2787">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-2788">
                  <MapPinIcon className="w-5 h-5 text-black" data-id="element-2789" />
                </div>
                <div data-id="element-2790">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-2791">
                    Paso 3
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-2792">
                    Busca un lugar tranquilo sin distracciones para la llamada
                  </p>
                </div>
              </div>

              {/* Step 4 */}
              <div className="flex items-start gap-4" data-id="element-2793">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-2794">
                  <PenLineIcon className="w-5 h-5 text-black" data-id="element-2795" />
                </div>
                <div data-id="element-2796">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-2797">
                    Paso 4
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-2798">
                    Ten papel y lápiz listo para tomar notas importantes
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* TESTIMONIALS */}
        <section data-id="element-2799">
          <div className="text-center mb-8" data-id="element-2800">
            <div className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 rounded-full px-4 py-2 mb-4" data-id="element-2801">
              <QuoteIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-2802" />
              <span className="text-sm font-semibold text-[#00f7fc] uppercase tracking-wide" data-id="element-2803">
                Lo Que Dicen Nuestros Estudiantes
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-5" data-id="element-2804">
            {/* Testimonial 1 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-2805">
              <div className="flex gap-1 mb-4" data-id="element-2806">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2807" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2808" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2809" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2810" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2811" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-2812" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-2813">
                "El sistema es claro, paso a paso y fácil de implementar. Me
                ayudó a entender cómo usar la IA en mi negocio de una manera que
                nunca había pensado."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-2814">
                <p className="font-bold text-white text-sm" data-id="element-2815">Carlos M.</p>
                <p className="text-gray-500 text-xs" data-id="element-2816">Miami, FL</p>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-2817">
              <div className="flex gap-1 mb-4" data-id="element-2818">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2819" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2820" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2821" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2822" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2823" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-2824" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-2825">
                "Lo que más me gustó fue lo práctico que es. No es teoría, es
                acción inmediata desde el primer día."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-2826">
                <p className="font-bold text-white text-sm" data-id="element-2827">Maria G.</p>
                <p className="text-gray-500 text-xs" data-id="element-2828">Hialeah, FL</p>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-2829">
              <div className="flex gap-1 mb-4" data-id="element-2830">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2831" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2832" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2833" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2834" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2835" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-2836" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-2837">
                "Nunca había usado IA para negocios. Ahora la uso todos los días
                y ha transformado completamente mi forma de trabajar."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-2838">
                <p className="font-bold text-white text-sm" data-id="element-2839">Roberto S.</p>
                <p className="text-gray-500 text-xs" data-id="element-2840">Doral, FL</p>
              </div>
            </div>
          </div>
        </section>

        {/* CLOSING NOTE */}
        <section className="text-center pb-4" data-id="element-2841">
          <div className="inline-flex items-center gap-3 bg-[#00f7fc]/10 border border-[#00f7fc]/20 rounded-2xl px-6 py-4" data-id="element-2842">
            <CheckCircleIcon className="w-5 h-5 text-[#00f7fc] flex-shrink-0" data-id="element-2843" />
            <p className="text-gray-300 text-sm md:text-base" data-id="element-2844">
              Nos vemos en la llamada. Prepárate para tomar acción.
            </p>
          </div>
        </section>
      </main>

      <Footer data-id="element-2845" />
      <WhatsAppButton data-id="element-2846" />
    </div>;
}